var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 27.6441,
    height: 47.8492,
    viewBox: "0 0 27.6441 47.8492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2861 36.8353V47.8492L0 41.2444V14.8194L8.17311 12.5527V35.0125L11.2861 36.8353Z",
    fill: "#6B97CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4592 31.3787V41.6172L11.2861 36.8353V11.6886L8.1731 12.5527V8.58746L16.3462 6.32077V29.5558L19.4592 31.3787Z",
    fill: "#4E7ABC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.6441 0V36.1664L19.4592 31.3786V5.45071L16.3462 6.32069V3.13076L27.6441 0Z",
    fill: "#305CA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMark);
export default __webpack_public_path__ + "static/media/mobile-mark.80049ed9eb28117129c29df011446b66.svg";
export { ForwardRef as ReactComponent };